import {PeriodContainer} from './PeriodContainer';

export default PeriodContainer;